
function EquipmentList() {
    /// <summary>
    /// This object provides js functions for the Widget.Equipment.List <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 14.1.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 14.1.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.listHeight = 0;
    this.currentDetailObj = null;
}

EquipmentList.prototype = new vcTemplate();

EquipmentList.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

   
        me.showInfo("", "", false);

        //init the full-ext search
        me.listHeight = parseInt(me.height - me.visual.find("#div-menu").height() - 20, 10);
        me.visual.find(".vc-list").height(me.listHeight);

        me.fetchEntries();

        me.visual.find("#div-filter").vcFilter({ callback: function () { me.hideDetails(); me.filter(); } });
        ////selections
        //me.visual.find("#chb-selection").off("click").on("click", function () { me.selectAll($(this)); });
		//me.visual.find("#chb-alarm-selection").off("click").on("click", function () { me.selectAllAlarms($(this)); });

        //me.visual.find(".equip-list .vc-list-selection").off("click", ".chb").on("click", ".chb", function (e) { me.activateBtnCmd(true); e.stopPropagation() });
        ////tasks (cmds)
        //me.visual.find("#ddl-cmd").off("change").on("change", function () { me.setCmd($(this)); });
        //me.visual.find("#txt-cmd").off("keyup").on("keyup", function () { me.activateBtnCmd(true); });
        //me.visual.find("#div-btn-send").off("click").on("click", function () { me.sendCmd(); });

        //me.visual.find(".equip-list .vc-list-selection").off("click", ".icon-del").on("click", ".icon-del", function (e) { me.delete($(this)); e.stopPropagation() });
        me.visual.find(".equip-list .vc-list-selection").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) { me.showDetails($(this)); e.stopPropagation() });
        me.visual.find("#div-btn-reload").off("click").on("click", function () { me.hideDetails(); me.fetchEntries(); });

        me.visual.find("#div-btn-new").off("click").on("click", function () {
          
            me.showDetails($(this));
            //    me.visual.find(".div-details-menu .button-toggle").removeClass("button-toggle-active");
            //    $(this).addClass("button-toggle-active");
            //    me.showDetailContent();
        }).button();

        //me.visual.find(".div-details .button-toggle").off("click").on("click", function () {
        //    me.visual.find(".div-details-menu .button-toggle").removeClass("button-toggle-active");
        //    $(this).addClass("button-toggle-active");
        //    me.showDetailContent();
        //}).button();

    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



EquipmentList.prototype.fetchEntries = function () {
    /// <summary>
    ///  This function generates a vc-list with all given entries. 
    /// </summary>
    var me = this;
    var sTmp = "";
   
    var list;
    var sError;
    //var sumTasks = 0;
    //var sumAlarms = 0;
    //var sumBroken = 0;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".equip-list .vc-list-selection").html(me.vcC.getLoadingIcon());

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({"type":1}),
       function (result) {

           if (result === null) { me.showMessage(me.resources.err_loadData, true);return false;}

           if (result.rows === null) {me.visual.find(".equip-list .vc-list-selection").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");return false;}


           for (var i = 0; i < result.rows.length; i++) {
              

               sTmp += "<li data-id='" + result.rows[i].id + "'  data-blid='" + result.rows[i].blid + "' class='vc-list-item ";

               if ((i % 2) === 0) {sTmp += "alt"} 
               if (result.rows[i].active === false) {
                   sTmp += " inactive";
               }
             
               sTmp += "'>";
               sTmp += "<div class='vc-list-col'>";
               sTmp += "<div class='vc-list-col vc-list-col-half'>";
               sTmp += "<div class='vc-list-col-element col1'>";
               sTmp += "<br/>";
               sTmp += "</div>"; //end col
               sTmp += "<div class='vc-list-col-element col2'>";
               sTmp += "<b>" + result.rows[i].name + "</b> ";
               sTmp += "<br/>" + result.rows[i].type_name + " (" + result.rows[i].group_name + ")";
               sTmp += "</div>"; //end col2
               sTmp += "<div class='vc-list-col-element col3'>";
               if (result.rows[i].serial !== null) {
                   sTmp += result.rows[i].serial + "";
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end col3
               sTmp += "<div class='vc-list-col-element col4'>";
               sTmp += "<div class='top'>";
               sTmp += "<div class='part'>";
               if (result.rows[i].coveragearea !== null) {
                   sTmp += result.rows[i].coveragearea;
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end
              
               sTmp += "<div class='part' >";
               if (result.rows[i].installationname !== null) {
                   sTmp += result.rows[i].installationname;
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end 
               sTmp += "<div class='part' >";
               if (result.rows[i].assignment !== null) {
                   sTmp += result.rows[i].assignment;
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end 
               sTmp += "</div>"; //end top
               sTmp += "<div class='bottom'>";
               if (result.rows[i].coveragearea !== null) {
                   sTmp += result.rows[i].coveragearea;
               }
               if (result.rows[i].installationname !== null) {
                   sTmp += " / " + result.rows[i].installationname;
               }
               if (result.rows[i].assignment !== null) {
                   if (result.rows[i].assignment.length > 0) {
                       sTmp += " / " + result.rows[i].assignment;
                   }
               }
               //if (result.rows[i].meterpoint.length > 0) {
               //    sTmp += result.rows[i].meterpoint;
               //} else {
               //    sTmp += "<br/>";
               //}
               sTmp += "</div>"; //end bottom

               sTmp += "</div>"; //end col3
              
               sTmp += "</div>"; //end col half
               sTmp += "<div class='vc-list-col vc-list-col-half'>";
               sTmp += "<div class='vc-list-col-element col5'>";
               if (result.rows[i].manufacturer !== null) {
                   sTmp += result.rows[i].manufacturer;
               } else {
                   sTmp += "-";
               }
               
               if (result.rows[i].make !== null) {
                   sTmp += " / " + result.rows[i].make;
               }
               sTmp += "<br/>";
               if (result.rows[i].class !== null) {
                   if (result.rows[i].class.length > 0) {
                       sTmp +=  result.rows[i].class;
                   }
               }
               if (result.rows[i].constructiondate !== null) {
                   sTmp += " (" + $.datepicker.formatDate('dd.mm.yy', result.rows[i].constructiondate) + ")";
               }
               sTmp += "</div>"; //end col5
               sTmp += "<div class='vc-list-col-element col6'>";
               if (result.rows[i].filingdate !== null) {
                   sTmp += $.datepicker.formatDate('dd.mm.yy', result.rows[i].filingdate);
               } else {
                   sTmp += "-";
               }
               sTmp += " / ";
               if (result.rows[i].signoffdate !== null) {
                   sTmp += $.datepicker.formatDate('dd.mm.yy', result.rows[i].signoffdate);
               } 
               
               sTmp += "</div>"; //end col6
               sTmp += "<div class='vc-list-col-element col7'>";
               if (result.rows[i].calibrationdate !== null) {
                   sTmp += $.datepicker.formatDate('dd.mm.yy', result.rows[i].calibrationdate);
               } else {
                   sTmp += "-";
               }
               sTmp += "</div>"; //end col7
               sTmp += "<div class='vc-list-col-element col8'>";
               sTmp += "<div class='pic'>";
               sTmp += "pic";
               // sTmp += "<img src='" + result.rows[i].pic + "' title='" + result.rows[i].unit + " (ID" + result.rows[i].bluid + ")' /><span style=' display: none;'>" + result.rows[i].unit + "</span>";
               sTmp += "</div>";
               sTmp += "</div>"; //end col8
               sTmp += "<div class='vc-list-col-element col9'>";

               if (result.rows[i].active) {
                   sTmp += "<i class='fa fa-power-off icon-color-ok'></i>";
               } else {
                   sTmp += "<i class='fa fa-power-off icon-color-error'></i>";
               }

               sTmp += "</div>"; //end col8
               sTmp += "<div class='vc-list-col-element col10'><i class='icon-del fa fa-times icon-color-error vc-list-icon'></i></div>"; //end col9
               sTmp += "</div>"; //end col half
               sTmp += "</div>"; //end col
               sTmp += "</li>"; //end item
           }
           me.visual.find(".equip-list .vc-list-selection").html(sTmp);

           me.filter();
           //me.hideDetails();

           //_VCMQ.produce(me.visual, me.vcgid, 'UNITSTATUS', { 'broken': sumBroken, "tasks": sumTasks, "alarms": sumAlarms });
           return true;
       });

        return true;
    } catch (ex) { me.writeError('fetchEntries', ex); return false }

}


EquipmentList.prototype.delete = function (obj) {
    /// <summary>
    ///  This function sends the id for the entry we want to delete to the server. 
    /// </summary>
    var me = this;
    var param;
    var id;
    var bluid;
    try {
        if (me.error) {
            return false;
        }

       // id = parseInt(obj.parents("li.vc-list-item").data("id"),10);
       // bluid = parseInt(obj.parents("li.vc-list-item").data("bluid"),10);
       // param = { "type": 2, "EntryList": [{"id": id, "bluid": bluid }]}
      

       // window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       //function (result) {
          
       //    if (result === false) {
       //        me.showMessage(me.resources.err_saveData, true);
       //        return false;
       //    }
       //    me.fetchEntries();
       //    return true;
       //});

        return true;
    } catch (ex) { me.writeError('delete', ex); return false }

}

EquipmentList.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find(".equip-list .vc-list-selection .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".equip-list .vc-list-selection .vc-list-item", "found");

        me.visual.find(".equip-list .vc-list-selection .vc-list-item.found").show();
        me.visual.find(".equip-list .vc-list-selection .vc-list-item").removeClass("alt");
        me.visual.find(".equip-list .vc-list-selection .vc-list-item.found:even").addClass("alt");
	    //me.selectAllAlarms(me.visual.find("#chb-alarm-selection"));
     
        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};


//EquipmentList.prototype.selectAll = function (obj) {
//    /// <summary>
//    /// This function handles the select/unselect functionality <br/>
//    /// </summary>
//    var me = this;
//    try {
//        if (me.error) { return false; }

//        if (obj.is(":checked")) {
//            me.visual.find(".vc-list-item.found input").prop("checked", true);
//            me.activateBtnCmd(true);
//        } else {
//            me.visual.find(".vc-list-item input").prop("checked", false);
//            me.activateBtnCmd(false);
//        }

//        return true;
//    } catch (ex) { me.writeError('selectAll', ex); return false; }
//};

//EquipmentList.prototype.selectAllAlarms = function (obj) {
//    /// <summary>
//    /// This function handles the select/unselect functionality of alarms<br/>
//    /// </summary>
//    var me = this;
//    try {
//        if (me.error) { return false; }

//	    if (obj.is(":checked")) {
//		    me.visual.find(".vc-list-item.found:has(.col5 .icon-color-ok)").hide();
//	    } else {
//		    me.visual.find(".vc-list-item.found:has(.col5 .icon-color-ok)").show();
//	    }
//	    me.visual.find(".equip-list .vc-list-selection .vc-list-item").removeClass("alt");
//        me.visual.find(".equip-list .vc-list-selection .vc-list-item.found:even").addClass("alt");

//        return true;
//    } catch (ex) { me.writeError('selectAll', ex); return false; }
//};




EquipmentList.prototype.showDetails = function (obj) {
    /// <summary>
    ///  This function opens/hides the detail view. When it opens the details it makes the vc-list smaller and shows the currently selected entry only.
    /// </summary>
    var me = this;
    var h;
    try {
        if (me.error) { return false; }
       
        if (me.visual.find(".div-details").is(":visible")) {
           return me.hideDetails();
        } else {
            me.visual.find(".div-details-menu .button-toggle").removeClass("button-toggle-active");
            me.visual.find(".div-details-menu #btn-detail-alarm").addClass("button-toggle-active");
            me.visual.find(".equip-list .vc-list-selection .vc-list-item").hide();
            //show the currently selected entry
            obj.show();
            
            h = parseInt(me.visual.find(".equip-list .vc-list-header").height() + obj.height() + 20, 10);
            me.visual.find(".vc-list.equip-list ").height(h);

            me.visual.find(".div-details-content").height(parseInt(me.listHeight - h - 50, 10));
            me.visual.find(".div-details").height(parseInt(me.listHeight - h, 10)).show();

            //save the current object for the detail menu
            me.currentDetailObj = obj;

            me.showDetailContent();

            return true;
        }

    } catch (ex) { me.writeError('showDetails', ex); return false }

}



EquipmentList.prototype.showDetailContent = function () {
    /// <summary>
    ///  This function opens a visual based on the selected menu point in the details. 
    /// </summary>
    var me = this;
    var type;
    var visual;
    var h;
    var w;
    var param;
    var signalParam;
    var id;
    var blid;
    var showVisual = false;
    try {
        if (me.error) { return false; }
        //get the type of the currently active button
        //type = me.visual.find(".div-details-menu .button-toggle-active").data("type");


        id = parseInt(me.currentDetailObj.data("id"), 10);
        blid = parseInt(me.currentDetailObj.data("blid"), 10);
        param = "true";
        signalParam = id;

        visual = "VISUAL_FORM_EQUIPMENT_DETAILS";
        h = parseInt($(".div-details-content").height(), 10);
        w = parseInt($(".div-details-content").width()-20, 10);


        //we generate a random sub container every time 
        var container = me.getRandomIDContainerObj("div-details-content-", true);
        me.visual.find(".div-details-content").html(container.obj);

        me.vcVisual.addVisualBaseByName("div-details-content-", visual, container.random, getCurrentTimestamp(), h, w, param, signalParam, 1);
        //}

        //switch (type) {
        //    case "alarm":
        //        visual = "VISUAL_ALARMHISTORY";

        //        if (bluid > 0) {
        //            param = JSON.stringify({"UnitID": bluid,"ShowUnitOnly": true,"AllProjects": false});
        //        } else {
        //            param = JSON.stringify({"LoggerID": blid,"AllProjects": false});
        //        }
        //        break;
        //    case "digital":
        //        visual = 'VISUAL_DIGITALTREND';
        //        showVisual = true;
        //        if (bluid > 0) {
        //            param = bluid;
        //            signalParam = JSON.stringify({ 'DigitalTrendType': 3 });
        //        } else {
        //            param = blid;
        //            signalParam = JSON.stringify({ 'DigitalTrendType': 1 });
        //        }

        //        break;
        //    case "tasks":
        //        visual = 'VISUAL_UNITSTATUS_TASKS';
        //        param = JSON.stringify({ 'UnitID': bluid, 'LoggerID': blid });
        //        signalParam = "";
        //        break;
        //    case "logs":
        //        visual = 'VISUAL_UNITSTATUS_LOGS';
        //        param = JSON.stringify({ 'UnitID': bluid, 'LoggerID': blid });
        //        signalParam = "";
        //        break;
        //default:
        //}
        //if (visual.length === 0) { return false }
        //if (showVisual) {
        //    me.vcVisual.addVisualByName("div-details-content-",visual,container.random,getCurrentTimestamp(),h,w,param,signalParam,1);
        //} else {
        //    me.vcVisual.addVisualBaseByName("div-details-content-",visual,container.random,getCurrentTimestamp(),h, w,param,signalParam,1);
        //}

        return true;

    } catch (ex) { me.writeError('showDetailContent', ex); return false }

}



EquipmentList.prototype.hideDetails = function () {
    /// <summary>
    ///  This function hides the details and resets the height of the vc-list
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find(".div-details").hide();
        me.visual.find(".vc-list.equip-list ").height(me.listHeight);
        me.filter();
        return true;
      
    } catch (ex) { me.writeError('hideDetails', ex); return false }

}

EquipmentList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
           me.visual.find(" #div-menu,.vc-list-header, .vc-list-selection").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


